export default __webpack_public_path__ + "static/media/map-pin-location-yesterday.eba31820.svg";